module.exports = __webpack_public_path__ + "img/dashboard.c8466311.svg";